import React from "react";

export const SinPermiso = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      overflow: "hidden",
      margin: 0,
      padding: 0,
    }}
  >
    <iframe
      src={`${process.env.REACT_APP_URL_LANDING}/sin-permisos`}
      style={{
        width: "100vw",
        height: "100vh",
        border: "none",
        overflow: "hidden",
      }}
      title="Sin permisos"
      frameBorder="0"
    />
  </div>
);
